export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filter-container.vue?vue&type=template&id=2c5d24cb&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter-container/filter-container.vue?vue&type=template&id=2c5d24cb&
// module id = 1166
// module chunks = 0